// Anchor Adequacy Banner — PSD §2.6 (F2.6). Builder Step 3.

import type { ValidationIssue } from '@backsolve/shared-types';

interface AnchorAdequacyBannerProps {
  issues: ValidationIssue[];
}

const ANCHOR_CODES = new Set(['ANCHOR_STALE', 'ANCHOR_NOT_ARMS_LENGTH', 'INVALID_ANCHOR_PRICE', 'ANCHOR_INSTRUMENT_MISSING']);

export function AnchorAdequacyBanner({ issues }: AnchorAdequacyBannerProps) {
  const anchorIssues = issues.filter((i) => ANCHOR_CODES.has(i.code));

  if (anchorIssues.length === 0) return null;

  const hasError = anchorIssues.some((i) => i.severity === 'error');

  return (
    <div className={`banner banner-${hasError ? 'error' : 'warning'}`} role="alert">
      <strong>Anchor Adequacy:</strong>
      <ul>
        {anchorIssues.map((iss, i) => (
          <li key={i}>
            <span className={`badge badge-${iss.severity === 'error' ? 'error' : 'warning'}`}>
              {iss.code}
            </span>{' '}
            {iss.message}
          </li>
        ))}
      </ul>
    </div>
  );
}
